import type { SitePhoto, SitePhotoPost } from './apiClient';

/**
 * The full-screen viewer's photo sequence: STRICTLY by capture time, newest
 * first, within each site day — the "sorted by date taken" gallery #328 asks
 * for.
 *
 * The feed can't be that strict on its own: it keeps a post's photos together
 * (one author, one caption), and two posts whose capture times overlap cannot
 * be both grouped and chronological. So the feed orders posts by their newest
 * photo and photos within a post newest first — one direction everywhere —
 * and the viewer, which isn't grouped, is the exact one (review of #560).
 *
 * A photo with no capture time (older uploads, stripped files) sorts by when
 * its post was made. Ties keep feed order, so the sequence is stable.
 */
export function viewerSequence(posts: SitePhotoPost[]): Array<{ post: SitePhotoPost; photo: SitePhoto }> {
  const items = posts.flatMap((post) => post.photos.map((photo) => ({ post, photo })));
  const key = (i: { post: SitePhotoPost; photo: SitePhoto }) => {
    const t = Date.parse(i.photo.takenAt ?? i.post.createdAt);
    return Number.isNaN(t) ? 0 : t;
  };
  return items
    .map((item, feedIndex) => ({ item, feedIndex, day: item.post.photoDate, t: key(item) }))
    .sort((a, b) =>
      (a.day === b.day ? 0 : a.day < b.day ? 1 : -1)   // site day, newest first
      || b.t - a.t                                        // then time taken, newest first
      || a.feedIndex - b.feedIndex)                       // then as the feed shows them
    .map((x) => x.item);
}
